import type {Transition, Variants} from 'framer-motion';

/** Pill (48px) plus the 12px breathing room above and below it — the whiteboard reserves this much so the canvas fits above the floating pill. */
export const MOBILE_TIMELINE_PILL_ROW_HEIGHT = 72;

export const MOBILE_TIMELINE_PILL_TRANSITION: Transition = {duration: 0.15, ease: 'easeOut'};

/** The pill settles up into place as it appears and drops back out of the way as the panel takes over. */
export const MOBILE_TIMELINE_PILL_VARIANTS: Variants = {
  hidden: {opacity: 0, y: 8, scale: 0.96},
  shown: {opacity: 1, y: 0, scale: 1},
};
